import styled from 'styled-components';

export const Container = styled.div`
  label {
    display: flex;
    align-items: center;

    position: relative;
    padding-left: 28px;

    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    & + label {
      margin-top: 10px;
    }

    /* Hide the browser's default checkbox */
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
      position: absolute;
      left: 0;
      height: 19px;
      width: 19px;
      background-color: var(--white);
      border: 1px solid var(--light-gray);
    }

    /* When the checkbox is checked, add a primary border */
    input:checked ~ .checkmark {
      border-color: var(--primary);
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: '';
      position: absolute;
      display: none;
    }

    /* Show the checkmark when checked */
    input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the checkmark/indicator */
    .checkmark:after {
      left: 6px;
      top: 4px;
      width: 4px;
      height: 8px;
      border: solid var(--primary);
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    .checkbox-text {
      font-size: 1.1rem;
      color: var(--gray);
      margin-top: 1px;
    }

    .checkbox-text-big {
      font-size: 1.3rem !important;
    }
  }
`;
